<template>
    <div id="customOrganizationPage" class="login-container" v-bind:style="getBackgroundCss">
        <loader class="color" v-if="$store.state.loginPage.loading"></loader>
        <div class="login-panel">
            <img :src="logo" alt="Navitas Group">
            <text-input label="E-mail / Username" hint="If you confirmed email, login with it, not username."
                        ref="username" @keyup.enter.native="actionLogin" :has-error="loginError" :error-message="loginErrorMessage"/>
            <password-input label="Password" ref="password" @keyup.enter.native="actionLogin" 
                           :has-error="loginError" :error-message="loginErrorMessage"/>
            <text-button style="transition: 0ms" label="Sign in" :loading-state="loadingState" @click="actionLogin"/>
            <div class="forgot-password-link">
                <a @click="actionForgotPassword">Forgot your password?</a>
            </div>
        </div>
    </div>

</template>
<script>
    import Login from "@/old/pages/Login";
    import customLoginPageMixin from "@/new/pages/OrganizationLogin/customLoginPageMixin";
    import Loader from "@/old/components/Loader";
    import AuthService from "../../services/AuthService";

    export default {
        name: "Login",
        components: {Loader},
        mixins: [Login, customLoginPageMixin],
        data() {
            return {
                ...Login.data(),
            }
        },
        methods: {
            /**
             * Override the actionLogin method to add error handling
             */
            actionLogin() {
                // Clear previous errors
                this.loginError = false;
                this.loginErrorMessage = '';
                
                this.loadingState = true;
                
                this.$api.login({
                    data: {
                        grant_type: 'password',
                        username: this.$refs.username.value,
                        password: this.$refs.password.value,
                        code: Object.prototype.hasOwnProperty.call(this.$refs, "code") ? this.$refs.code.value : null,
                    }
                }).then(({data}) => {
                    
                    // Reset failed attempts on successful login
                    this.failedAttempts = 0;
                    
                    // Attempt to login the user
                    AuthService.login(data)

                    // If the app is running in React Native, send the data to the app
                    if(typeof window.ReactNativeWebView !== 'undefined') {
                        window.ReactNativeWebView.postMessage(JSON.stringify(data));
                    }

                    AuthService.redirectUserToTheOldAppOrDashboard();
                    

                }).catch(({data, error}) => {
                    
                    // Did the login fail because a 2FA code is required? 
                    if (data !== undefined && data !== null) {
                        if (Object.prototype.hasOwnProperty.call(data, "_2fa_enabled") === true) {
                            if (data._2fa_enabled === 1) {
                                this.showFACode = true;
                                return; // Don't count this as a failed attempt
                            }
                        }
                    }

                    // Other error
                    if (error !== undefined && error !== null && error.status === 418) {
                        let token = data.token ?? '';
                        let email = data.email ?? '-';
                        let routePath = this.$enums.RoutePathEnum.ACCOUNT_CONFLICT;
                        routePath = routePath.replace(':token', token);
                        routePath = routePath.replace(':email', email);
                        this.$router.push(routePath);
                        return; // Don't count this as a failed attempt
                    }

                    // Handle login failure
                    this.failedAttempts++;
                    this.loginError = true;
                    this.loginErrorMessage = 'Invalid account or password. Click the eye icon to reveal password.';

                    // Check if we've reached the maximum failed attempts
                    if (this.failedAttempts >= this.maxFailedAttempts) {
                        // Redirect to forgot password page
                        this.actionForgotPassword();
                    }

                }).finally(() => {
                    this.loadingState = false;
                });
            },
            /**
             * Using router name not from enum because params work only with named routes!
             * https://router.vuejs.org/guide/essentials/navigation.html
             */
            actionForgotPassword() {
                this.$router.push({
                    name: 'CustomOrganizationForgotPassword',
                    params: {organization: this.$route.params.organization}
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .loader {
        background: whitesmoke;
        z-index: 2;
    }
</style>
